import fr from 'facet-rest';
import TransactionsDetailStat from 'Views/Page/Content/Modal/Layouts/TransactionDetails/TransactionsDetailStat';
import { BaseOverrideNoHidden } from '../../../Templates/BaseOverride';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .nameOverride(name => !['iraContributionApplyToPriorYear', 'iraContributionType'].includes(name),
    { _component: () => TransactionsDetailStat }, {
      ordinal: 201,
    })
  .override(
    { name: 'iraContributionApplyToPriorYear', readonly: true },
    { hidden: true }, { ordinal: 203 },
  )
  .override(
    { name: 'iraContributionType', readonly: true },
    { _component: () => TransactionsDetailStat }, { ordinal: 203 },
  )
  .nameOverride(['title', 'subtitle'], { hidden: true }, { ordinal: 203 });
